import { useEffect } from 'react'
import {
    Grid, Typography, Box, IconButton, List, ListItem, ListItemAvatar, ListItemText,
    ListItemSecondaryAction, CircularProgress, LinearProgress
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { handleLanguageChange } from '../../utils/multiLangDashboardV2Data';
import { QueryRenderer } from '@cubejs-client/react'
import { url } from '../../config/urls'
import cubejs from '@cubejs-client/core'
import settings from "../../config/settings";
import { StringTruncate } from '../../utils/Reusables';
import { ReactComponent as ReportChart } from "../../assets/icons/icon-report-data.svg"
import {Skeleton} from '@mui/material';

const API_URL = url.cubeApiUrl
const CUBE_PUBLISHED_URL = url.cubePublishedApiUrl

const formatCustomData = (data) => {
    data.forEach(ele => {
        if (Object.keys(ele).length) {
            Object.keys(ele).forEach(k => {
                if (!ele[k]) {
                    ele[k] = 0
                }
            })
        }
    })
    return data
}

const formatStudentReportQuery = (studentId,keyMarksMetricsQuery) => {
    if(studentId && keyMarksMetricsQuery) {
            let dataSetName = null;
            if (keyMarksMetricsQuery.dimensions?.length > 0) {
                dataSetName = keyMarksMetricsQuery.dimensions[0]?.split('.')[0];
            }
            else if (keyMarksMetricsQuery.measures?.length > 0) {
                dataSetName = keyMarksMetricsQuery.measures[0]?.split('.')[0];
            }
            
            if(keyMarksMetricsQuery?.filters?.length ) {
                let ifExist = keyMarksMetricsQuery?.filters?.find(f => f?.member.includes('sUuid'))
                if(ifExist) {
                    ifExist.values = [studentId]
                }
                else {
                      keyMarksMetricsQuery?.filters.push({
                          member : `${dataSetName}.sUuid`,
                          operator: 'equals',
                          values: [studentId]
                      })

                }
            }
            keyMarksMetricsQuery = formatQueryFilter(keyMarksMetricsQuery)
            return keyMarksMetricsQuery
    }
    keyMarksMetricsQuery = formatQueryFilter(keyMarksMetricsQuery)
    return keyMarksMetricsQuery
}

const formatQueryFilter = (query) => {
    if(query?.filters?.length ) {
        query?.filters?.map(f => {
            if(f?.values && typeof f?.values[0] === 'number') {
                f.values = f?.values?.map(v => v?.toString())
            }
        })    
    }
    return query
 }




const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 3,
        borderRadius: 4,
    },
    colorPrimary: {
        backgroundColor: '#dedede',
    },
    bar: {
        borderRadius: 5,
        backgroundColor: '#F45E29',
    },
}))(LinearProgress);

const KeyMarksPerformanceCard = (props) => {
    let cubejsApi = ""
    const CUBE_TOKEN = localStorage.getItem('cubeToken')
    if (CUBE_TOKEN)
        cubejsApi = cubejs(CUBE_TOKEN, { apiUrl: `${CUBE_PUBLISHED_URL}/cubejs-api/v1` })


    let { item, selectedProfile, profileReportIds, mapSubjectIconData, handleCustomDataFilter, handleCustomProfileDataFilter, handleCustomDateFilter, keyMarksMetricsQuery,studentId } = props
    let { keyMarksPerformanceMetrics } = settings?.STUDENT_DASHBOARD_QUERY ?? {}
    let { leastPerform } = settings?.STUDENT_DASHBOARD_CALCULATED_FIELDS ?? {}


    

    if (!keyMarksMetricsQuery) {
        return null
    }

    if (selectedProfile?.length && profileReportIds?.length && !profileReportIds.includes('keyMarksPerformanceMetrics')) {
         return null
     }

    return (
        <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box className='er-keyareas er-keyareas-marks'>
                <Box className="er-keyareas-heading">
                    <Typography variant='h4' >{handleLanguageChange("Test and Practice-Test Performance")}</Typography>
                </Box>
                <Box className="er-keyareas-content">
                    <List className='er-keyareas-items'>
                        <QueryRenderer
                            query={formatStudentReportQuery(studentId,keyMarksMetricsQuery)}
                            cubejsApi={cubejsApi}
                            render={({ resultSet, loadingState }) => {
                                if (!resultSet || loadingState?.isLoading) {
                                    return <Box className="width-100"> 
                                                <Skeleton className='progress-skeleton' animation="wave" />
                                                <Skeleton className='progress-skeleton half' animation="wave" />
                                            </Box>
                                }

                                let data1 = resultSet?.loadResponse?.results?.[0]?.data


                                if (data1?.length) {
                                    data1 = formatCustomData(data1)

                                    let keyAreaStats1 = data1.map(ele => {
                                        return {
                                            subject: ele[`${settings.STUDENT_ASSESSMENT_DATASET}.subject`],
                                            time: Math.round(ele[leastPerform], 2)
                                        }
                                    })

                                    return keyAreaStats1.map((item, i) => (
                                        <ListItem key={i}>
                                            <Box>
                                                <ListItemAvatar>
                                                    {mapSubjectIconData(item?.subject)}
                                                </ListItemAvatar>
                                            </Box>
                                            <Box sx={{ width: '100%' }}>
                                                <Box>
                                                    <ListItemText title={item?.subject} className="label er-keyareas-content-item-title" primary={StringTruncate(item?.subject, 20)} />
                                                    <ListItemSecondaryAction>
                                                        <IconButton className='form-icon-btn ' edge="end" aria-label="">
                                                            <Typography className="action-label" >{(item?.time ? item?.time : 0) + '%'}</Typography>
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </Box>
                                                <Box sx={{ width: '100%', mt: 1.5 }}>
                                                    <BorderLinearProgress variant="determinate" value={parseInt(item?.time)} />
                                                </Box>
                                            </Box>
                                        </ListItem>
                                    ))
                                }

                                return (<Box className="width-100 text-center">
                                    <Box className='er-report-data-icon'><ReportChart /></Box>
                                    <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange('No Data Found')}</Typography>
                                </Box>)
                            }}
                        />
                    </List>
                </Box>
            </Box>
        </Grid>
    )
}

export default KeyMarksPerformanceCard